export default __webpack_public_path__ + "static/media/chat-2.b74a6f9c.PNG";